/**
 * Tracking analítico para la ruta /conoce-los-puntos-hop.
 * Empuja el evento `punto_hop_como_llegar` al dataLayer de GTM
 * cuando el usuario clickea el CTA "Cómo llegar" desde la lista o el popup.
 *
 * @param {object} punto  - El punto HOP seleccionado
 * @param {'lista'|'popup'} source  - Origen del clic
 * @param {'geolocalizacion'|'direccion'} searchMethod  - Cómo llegó el usuario
 */
export const trackComoLlegar = (punto, source, searchMethod = 'direccion') => {
  if (typeof window === 'undefined') return;

  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${punto.lat},${punto.lng}`;

  const payload = {
    event: 'punto_hop_como_llegar',
    punto_id: punto.id,
    punto_nombre: punto.name,
    punto_direccion: punto.full_address || `${punto.street} ${punto.door_number || ''}`.trim(),
    punto_lat: punto.lat,
    punto_lng: punto.lng,
    maps_url: mapsUrl,
    source,
    search_method: searchMethod,
    timestamp: new Date().toISOString()
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

/**
 * Construye la URL de Google Maps direcciones para un punto.
 * @param {object} punto
 * @returns {string}
 */
export const buildMapsUrl = (punto) =>
  `https://www.google.com/maps/dir/?api=1&destination=${punto.lat},${punto.lng}`;